import { createLucideIcon } from "lucide-react";

export const Share = createLucideIcon(
    "Share",
    [
        [
            "path",
            {
                d: "M11.1002 3C7.45057 3.00657 5.53942 3.09617 4.31806 4.31754C3 5.63559 3 7.75698 3 11.9997C3 16.2425 3 18.3639 4.31806 19.6819C5.63611 21 7.7575 21 12.0003 21C16.243 21 18.3644 21 19.6825 19.6819C20.9038 18.4606 20.9934 16.5494 21 12.8998",
                key: "2fj3oa",
            },
        ],
        [
            "path",
            {
                d: "M20.9995 6.0252C20.9934 6.171 20.9352 6.316 20.8249 6.4467C20.0596 7.353 18.0711 8.9999 18.0711 8.9999",
                key: "12c0pp",
            },
        ],
        [
            "path",
            {
                d: "M20.9995 6.0252C21.0062 5.8625 20.9481 5.6989 20.8251 5.5532C20.0599 4.6467 18.0711 2.9999 18.0711 2.9999",
                key: "1cdrgp",
            },
        ],
        [
            "path",
            {
                d: "M20.9995 6.0252L20 6.0226C16.2634 6.0132 14.3951 6.0085 13.0817 6.9525C12.6452 7.2663 12.2622 7.6483 11.9474 8.084C11 9.395 11 11.2633 11 14.9999",
                key: "1uicn2",
            },
        ],
    ],
);
